<template>
    <v-layout justify-space-around row wrap >
        <v-flex v-if="loadedOnce" >
            <div v-for="(post, id) in posts" :key="id" class="post">
                <v-card class="round-card">

                    <v-card-title primary-title >
                        <div>
                            <div class="headline">  <strong> {{post[1].title}} </strong> </div> 
                            <span class="grey--text"> {{post[1].date}} </span>
                        </div>
                    </v-card-title>

                    <v-img :src="post[1].img" :max-height="500"></v-img>

                    <v-card-text>
                        <span v-html="post[1].content"></span> <br>
                    </v-card-text>

                    <v-card-actions>
                        <social-sharing :url=" 'http://www.peccinin.adv.br/feed/' + post[0]"
                      :title="post[1].title"
                      :description="post[1].title"
                      :quote="post[1].title"
                      inline-template>
                            <div >
                                <network style="margin-left: 8px; margin-right: 16px; cursor:pointer" network="facebook" >
                                     <font-awesome-icon  :icon="{ prefix: 'fab', iconName: 'facebook' }" size="lg"/> 
                                </network>
                                <!-- <network network="linkedin">
                                    <i class="fa fa-linkedin"></i> LinkedIn
                                </network> -->
                                <network style="margin-left: 8px; margin-right: 16px; cursor:pointer" network="twitter">
                                    <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" size="lg"  /> 
                                </network>
                                <network style="margin-left: 8px; margin-right: 16px; cursor:pointer" network="whatsapp">
                                    <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'whatsapp' }" size="lg"  />  
                                </network>
                            </div>
                        </social-sharing>
                    </v-card-actions>
                </v-card>
            </div>
        </v-flex>

        <v-flex  v-if="!postsLoaded" class="center-progress" xs12 >
            <v-progress-circular class="mx-auto" 
            indeterminate
            color="secondary"
            ></v-progress-circular>
        </v-flex>

    </v-layout>
</template>

<script>
import base from '../plugins/firebase'

export default {
    props: ['postKey'],

    data() {
        return {
            posts: [],
            ref: base.database().ref("posts"),

            dismissSecs: 5,
            dismissCountDown: 0,
            postsLoaded: false,
            loadedOnce: false,
            postOffset: 0,
            sendLoaded: true,
            refreshLoaded: true,
            scrolledToBottom: false
        }
    },

    created(){
        this.get()
    },

    watch: {
        scrolledToBottom: function () {
            if (this.scrolledToBottom && this.postsLoaded && this.loadedOnce){
                this.get();
            }
        }
    },
    mounted () {
        this.scroll()
    },
    methods: {
        scroll () {
            window.onscroll = () => {
                let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight 

                if (bottomOfWindow) {
                    this.scrolledToBottom = true 
                }
            }
        },

        get() {
            this.postsLoaded = false
            this.ref.orderByKey().limitToLast(6 + this.postOffset).once('value')
            .then(snapshot => {
                var result = snapshot.val()
                if(result != null){
                    this.posts = Object.entries(result)

                    if(this.postKey != null ){
                        // Index do post no array vem da key do objeto do firebase
                        var index  = this.posts.findIndex(this.findPost);
                            this.posts = this.posts.slice(0, index + 1)
                    }

                    this.posts = this.posts.reverse()

                }
                else {
                    this.posts = []
                }

                this.postsLoaded = true
                this.loadedOnce = true
                this.postOffset += 3;
                this.scrolledToBottom = false
            })
        },

        findPost(post){
            return post[0] == this.postKey
        }
    }

}
</script>

<style scoped>
.post {  
    padding-bottom: 20px;
}

img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.image-style-side img {
    max-width: 50%;
    max-height: 50%;
    float: right;
}

.social-icon svg:hover{
    fill: #6ba348 !important;
    color: #6ba348 !important;
}

</style>
